import { Modal, Box, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./poweredByUpgradeModal.css";

const PoweredByUpgradeModal = ({
  open,
  onClose,
  bot,
  onUpgrade,
  title,
  description,
  requiredPlan,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  const resolvedTitle = title || t('premium_feature');
  const resolvedDescription =
    description || t('powered_by_upgrade_description');
  const resolvedRequiredPlan = requiredPlan || 'Boost+';

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        outline: 'none',
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "20px",
          width: "100%",
          maxWidth: "500px",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
          outline: 'none',
          position: 'relative',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'text.secondary',
            '&:hover': { color: 'text.primary' },
          }}
          aria-label="close"
        >
          <FontAwesomeIcon icon={faXmark} />
        </IconButton>
        <div className="powered-by-upgrade-modal-content">
          <div className="powered-by-upgrade-modal-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h2 className="powered-by-upgrade-modal-title">{resolvedTitle}</h2>
          
          <p className="powered-by-upgrade-modal-description">
            {resolvedDescription}
          </p>
          
          <div className="powered-by-upgrade-plan-info">
            <div className="powered-by-upgrade-plan-badge powered-by-upgrade-current-plan">
              <span className="powered-by-upgrade-plan-label">{t('current_plan')}</span>
              <span className="powered-by-upgrade-plan-name">{bot?.subscription_plan?.name || 'Free'}</span>
            </div>
            <div className="powered-by-upgrade-arrow-icon">→</div>
            <div className="powered-by-upgrade-plan-badge powered-by-upgrade-required-plan">
              <span className="powered-by-upgrade-plan-label">{t('powered_by_upgrade_required')}</span>
              <span className="powered-by-upgrade-plan-name">{resolvedRequiredPlan}</span>
            </div>
          </div>
          
          <button
            className="powered-by-upgrade-button"
            onClick={onUpgrade}
          >
            {t('billing_upgrade_now')}
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default PoweredByUpgradeModal;
